<div class="surface relative h-full w-full">
  <sia-ai-grid-filter
    (applyFiltersEvent)="applyFilters($event)"
    [(queryText)]="queryText"
    [aiGeneratedFilters]="aiGeneratedFilters()"
    #searchBox
  ></sia-ai-grid-filter>
  <div
    class="flex h-full w-full flex-row p-2"
    [style.max-height]="
      'calc(100% - ' +
      searchBox.elementRef.nativeElement.offsetHeight +
      'px - ' +
      bottomSection.offsetHeight +
      'px)'
    "
  >
    <div
      class="surface-lowest relative flex h-full w-full flex-col rounded-lg transition-all duration-300"
      [class.md:!w-full]="!sidebarFile()"
      [class.!w-full]="isMobile()"
      [style.width]="
        sidebarFile() && !isMobile() ? 'calc(100% - 40vw - 0.5rem)' : '100%'
      "
    >
      <!-- Full Loading Spinner (when searching) - occupies whole space and centered with labels -->
      @if (isSearching()) {
        <div
          class="flex h-full w-full flex-col items-center justify-center gap-4"
        >
          @if (queryTextUsedForSearch()) {
            <div class="flex items-center gap-2 md:gap-4">
              <h3
                class="text-lg font-semibold md:text-xl"
                [style.color]="'var(--ai-shade-2)'"
              >
                {{ 'Kitsune sta cercando...' | siaTranslate }}
              </h3>
              <img
                src="./assets/ai/ai-search-icon.png"
                class="h-8 w-8 md:h-12 md:w-12"
              />
            </div>
          }
          <mat-spinner
            [diameter]="queryTextUsedForSearch() ? 50 : 60"
            [class.ai-spinner]="queryTextUsedForSearch()"
            class="md:!h-[60px] md:!w-[60px]"
          ></mat-spinner>
          @if (queryTextUsedForSearch()) {
            <p
              class="px-4 text-center text-xs text-gray-600 dark:text-gray-400 md:text-sm"
            >
              {{
                'Analisi dei documenti in corso per trovare i risultati più pertinenti'
                  | siaTranslate
              }}
            </p>
          }
        </div>
      }

      @if (!isSearching() && displayedFiles().length === 0) {
        <div
          class="flex h-full w-full flex-col items-center justify-center gap-4 p-4 md:p-8"
        >
          <img
            src="./assets/ai/ai-empty-search.png"
            class="h-12 w-12 md:h-20 md:w-20"
          />
          <h3
            class="px-4 text-center text-lg font-semibold text-gray-700 dark:text-gray-300 md:text-xl"
          >
            {{
              queryTextUsedForSearch()
                ? ('Nessun risultato trovato per' | siaTranslate)
                : ('Nessun risultato trovato' | siaTranslate)
            }}
            {{
              queryTextUsedForSearch()
                ? '"' + queryTextUsedForSearch() + '"'
                : ''
            }}
          </h3>
          @if (!this.loadRelevantFiles() || this.relevantFilesCount() == 0) {
            <p
              class="max-w-md px-4 text-center text-xs text-gray-600 dark:text-gray-400 md:text-sm"
            >
              {{
                'La ricerca non ha prodotto risultati. Prova a modificare i termini di ricerca o i filtri applicati.'
                  | siaTranslate
              }}
            </p>
          }
          @if (this.loadRelevantFiles() && this.relevantFilesCount() > 0) {
            <button mat-button class="primary" (click)="loadLessRelatedFiles()">
              Carica anche meno pertinenti
            </button>
          }
        </div>
      }

      <!-- Virtual scroll viewport - hidden when searching or no results -->
      <cdk-virtual-scroll-viewport
        #aiFilesList
        [hidden]="isSearching() || displayedFiles().length === 0"
        class="w-full transition-all duration-300"
        [style.height]="
          showMoreFilesVisible()
            ? isMobile()
              ? 'calc(100% - 60px)'
              : 'calc(100% - 80px)'
            : '100%'
        "
        [style.width]="'100%'"
        itemSize="120"
        minBufferPx="600"
        maxBufferPx="1200"
        (scrolledIndexChange)="onScrollIndexChange($event)"
      >
        <div class="flex w-full flex-col gap-1 p-1 md:gap-2 md:p-2">
          <!-- Relevant Files Count Label - now inside virtual scroll -->
          @if (relevantFiles().length > 0) {
            <div class="flex items-center gap-2 rounded-lg px-4 py-3">
              <mat-icon class="text-base" [style.color]="'var(--ai-shade-2)'">
                auto_awesome
              </mat-icon>
              <span class="text-sm font-medium">
                <span [style.color]="'var(--ai-shade-2)'" class="font-semibold">
                  {{ relevantFiles().length }}
                </span>
                {{
                  relevantFiles().length === 1
                    ? ('documento pertinente per' | siaTranslate)
                    : ('documenti pertinenti per' | siaTranslate)
                }}
              </span>
              <span class="text-sm"> "{{ queryTextUsedForSearch() }}" </span>
            </div>
          }

          @for (
            file of displayedFiles();
            track file.sha256;
            let i = $index;
            let last = $last
          ) {
            <!-- Show "Altri documenti" label when transitioning from relevant to non-relevant files -->
            @if (
              relevantFiles().length > 0 &&
              i === relevantFiles().length &&
              !last
            ) {
              <div
                class="mt-2 flex items-center gap-2 rounded-lg px-4 py-3 md:mt-4"
              >
                <mat-icon class="text-base text-gray-500">folder_open</mat-icon>
                <span
                  class="text-sm font-medium text-gray-600 dark:text-gray-400"
                >
                  {{ 'Altri documenti' | siaTranslate }}
                </span>
              </div>
            }
            <sia-ai-grid-file
              [file]="file"
              [viewMode]="viewMode()"
              (selectionChange)="toggleSelection($event.file, $event.checked)"
              (addFileToDossier)="addFileToDossier($event)"
              [isRelevant]="isRelevant(file)"
              [isAnimatingIn]="file._isAnimatingIn ?? false"
              (onRowClicked)="setSidebarFile($event)"
              (onImgClicked)="setShowPreview($event)"
              [isSelected]="sidebarFile()?.sha256 == file.sha256"
              [isChecked]="selectedItemsIds().includes(file.sha256)"
            ></sia-ai-grid-file>
          }
          <!-- Simple Loading Spinner at bottom (when loading more) -->
          @if (isLoadingMore()) {
            <div class="flex w-full items-center justify-center py-4">
              <mat-spinner [diameter]="40"></mat-spinner>
            </div>
          }
        </div>
      </cdk-virtual-scroll-viewport>

      <div [hidden]="isSearching() || displayedFiles().length === 0">
        @if (showMoreFilesVisible() && this.relevantFiles().length > 0) {
          <div
            class="flex h-[60px] w-full items-center justify-center md:h-[80px] md:p-2"
          >
            <button mat-flat-button (click)="startToShowMoreFiles()">
              {{ 'Mostra tutti i file' | siaTranslate }}
            </button>
          </div>
        }
      </div>
    </div>

    <!-- Side Details Panel - Hidden on mobile -->
    <div
      class="surface-lowest absolute z-10 h-full overflow-hidden rounded-lg transition-all duration-300 md:relative md:block"
      [class]="
        !sidebarFile()
          ? isMobile()
            ? 'left-full w-full'
            : '!w-0'
          : isMobile()
            ? 'inset-0 w-full'
            : 'ml-2 !w-[40vw] !min-w-[40vw]'
      "
    >
      <div
        class="flex w-full flex-row items-center gap-2 p-2"
        [class.justify-between]="viewMode() === 'standard'"
        #filePreviewHeader
      >
        @if (viewMode() === 'standard') {
          <div class="flex flex-col" [style.width]="'calc(100% - 1rem - 2rem)'">
            <span
              class="text-outline truncate text-lg font-semibold"
              [title]="sidebarFile()?.name"
              >{{ sidebarFile()?.name }}</span
            >
            @if (sidebarFile()?.paths && (sidebarFile()?.paths)!.length > 0) {
              <span
                class="w-fit max-w-full cursor-pointer truncate text-xs hover:underline"
                [style.direction]="'rtl'"
                (click)="
                  copyToClipboard(sidebarFile()!.paths![0], 'Percorso copiato');
                  $event.stopPropagation()
                "
              >
                @if (sidebarFile()!.paths!.length > 1) {
                  <span
                    class="text-primary text-sm"
                    [siaTooltip]="sidebarFile()!.paths!.join('\n')"
                  >
                    {{ sidebarFile()!.paths!.length - 1 }}+
                  </span>
                }
                <bdi>{{ (sidebarFile()?.paths)![0] }}</bdi>
              </span>
            }
          </div>
          <button
            mat-icon-button
            class="h-8 w-8 transition-colors duration-200 sm:h-7 sm:w-7"
            (click)="closeFileDetails()"
          >
            <mat-icon>close</mat-icon>
          </button>
        } @else {
          <button mat-icon-button (click)="setViewModeStandard()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          @if (updateNameDossier()) {
            <div class="flex flex-1 items-center gap-2">
              <sia-text-box
                label="Nome dossier"
                [(value)]="dossier().name"
                class="flex w-1/2"
              ></sia-text-box>
              <button mat-icon-button (click)="saveDossierName()">
                <mat-icon>check</mat-icon>
              </button>
              <button mat-icon-button (click)="updateNameDossier.set(false)">
                <mat-icon>undo</mat-icon>
              </button>
            </div>
          } @else {
            <span
              class="text-outline truncate text-lg font-medium"
              [title]="dossier().name"
              >{{ dossier().name }}</span
            >
            <button mat-icon-button (click)="updateNameDossier.set(true)">
              <mat-icon>edit</mat-icon>
            </button>
          }
        }
      </div>
      <div
        class="flex w-full flex-row gap-2 rounded-lg"
        [style.height]="
          'calc(100% - ' + filePreviewHeader.offsetHeight + 'px - 0.5rem)'
        "
      >
        <div class="h-full w-full">
          <sia-ai-file-grid-details
            [file]="sidebarFile()"
            [(viewMode)]="viewMode"
            [(dossier)]="dossier"
            [selectedFiles]="selectedItems()"
            [(showPreview)]="showPreview"
            [showFileName]="false"
            (fileRemovedFromDossier)="onFileRemovedFromDossier($event)"
          ></sia-ai-file-grid-details>
        </div>
      </div>
    </div>
  </div>
  <!-- Bottom Section for Chat Selection -->
  <div
    class="surface-lowest relative mx-2 mb-2 overflow-hidden rounded-lg"
    [class.h-[60px]]="selectedItems().length === 0"
    [class.h-[200px]]="selectedItems().length > 0"
    [class.md:h-[180px]]="selectedItems().length > 0"
    #bottomSection
  >
    <!-- Empty State -->
    <div
      class="absolute inset-0 flex items-center justify-center gap-2 text-center"
      [style.opacity]="selectedItems().length === 0 ? '1' : '0'"
      [style.pointer-events]="selectedItems().length === 0 ? 'auto' : 'none'"
    >
      <span class="text-base">Seleziona i documenti per</span>
      <span class="text-base font-semibold text-ai-shade-2">chattare</span>
    </div>

    <!-- Selected Files State -->
    <div
      class="absolute inset-0 flex flex-col p-2 md:p-3"
      [style.opacity]="selectedItems().length > 0 ? '1' : '0'"
      [style.pointer-events]="selectedItems().length > 0 ? 'auto' : 'none'"
    >
      <!-- Header with title and clear button -->
      <div class="mb-1 flex items-center justify-between gap-2 md:mb-2">
        <div class="flex min-w-0 flex-1 items-center gap-1.5">
          <mat-icon class="flex-shrink-0 text-base text-[var(--ai-shade-2)]"
            >description</mat-icon
          >
          <span class="whitespace-nowrap text-sm font-medium"
            >Documenti selezionati</span
          >
          <span
            class="flex-shrink-0 text-sm font-semibold text-[var(--ai-shade-2)]"
            >({{ selectedItems().length }})</span
          >
        </div>

        <button
          mat-button
          class="!min-w-0 flex-shrink-0 !px-2 !py-1 !text-xs transition-opacity hover:opacity-90"
          (click)="clearAllSelections()"
        >
          Rimuovi
        </button>
      </div>

      <!-- Selected Files Grid - scrollable with max 2 rows -->
      <div class="flex-1 overflow-y-auto py-1 pr-1 md:py-2 md:pr-2">
        <div class="grid grid-cols-1 gap-1.5 md:grid-cols-3 lg:grid-cols-4">
          @for (file of selectedFilesData(); track file.sha256) {
            <div
              class="surface-high border-primary group relative flex cursor-pointer items-center gap-1.5 rounded-md border-2 border-solid p-1.5 transition-all duration-200 hover:shadow-md md:p-2"
              [style.background]="
                'color-mix(in srgb, var(--mat-sys-primary) 5%, transparent)'
              "
            >
              <!-- File icon based on file type -->
              <mat-icon
                class="flex-shrink-0 !text-base md:!text-lg"
                [style.color]="file.color"
              >
                {{ file.icon }}
              </mat-icon>

              <!-- File name -->
              <div class="min-w-0 flex-1">
                <div
                  class="truncate text-xs font-medium md:text-sm"
                  [title]="file.name"
                >
                  {{ file.name | truncateFilename: 30 : 10 : 10 }}
                </div>
              </div>

              <!-- Close icon to deselect -->
              <button
                mat-icon-button
                class="!h-4 !w-4 !min-w-0 flex-shrink-0"
                (click)="$event.stopPropagation(); toggleSelection(file, false)"
              >
                <mat-icon class="!text-sm">close</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>

      <!-- Chat Button - Always at bottom -->
      <div class="flex items-center justify-center pt-1.5">
        <button
          mat-flat-button
          class="!h-10 w-full !text-sm transition-opacity hover:opacity-90 md:!h-12 md:w-auto md:!px-6"
          style="background: var(--ai-shade-2); color: white"
          (click)="openChatWithSelectedDocuments()"
        >
          <mat-icon class="mr-2 !text-base">north</mat-icon>
          Chatta con i documenti selezionati
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Fullscreen Preview (gestito da ai-preview-handler) -->
@if (isFullscreenPreview()) {
  <ai-preview-handler
    [fileSha256]="fullscreenPreviewFile()?.sha256 ?? ''"
    [fileName]="fullscreenPreviewFile()?.name ?? ''"
    [fileType]="fullscreenPreviewFile()?.type"
    [(isFullscreenMode)]="isFullscreenPreview"
    [horizontal]="false"
  ></ai-preview-handler>
}
